module.exports = __webpack_public_path__ + "h5/img/add_02.93a7ab3d.png";